module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAARCAYAAAAVKGZoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHlJREFUeNpinLpb8T8DGmBiwAJIE/yDRZDREWjTIxTBbNd7R5h+/jVgYPi/DptRDNN2KWQAnfiNQTNDWQdZYvpOIF87S+mbTqZSBrIEI1AQ5qN1TP//pFye/ug9siBQCcOj//8ZolEd/59BjpGBYT82H7FQGCAAAQYAqX4kLTk6E6sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot/titleicon.png
// module id = JZZS
// module chunks = 1